<template>
  <div id="content-container">
    <div id="page-head">
      <div id="page-title">
        <h1 class="page-header text-overflow">复合片记录</h1>
      </div>
      <ol class="breadcrumb">
        <li><i class="ion-home"></i></li>
        <li>钻头列表</li>
        <li class="active">复合片记录</li>
      </ol>
    </div>
    <div id="page-content">
      <div class="panel">
        <div class="panel-body p-t-15 p-b-0">
          <router-link
            to="/stock/drills"
            class="btn btn-sm btn-icon btn-purple"
          >
            <i class="ion-arrow-left-c"></i> 返回列表
          </router-link>
        </div>
        <hr />
        <div class="panel-heading">
          <h3 class="panel-title">
            钻头序列号：<DrillLink :no="drill.serial_number"></DrillLink>
          </h3>
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-striped table-vcenter">
              <thead>
                <tr>
                  <th width="10%">时间</th>
                  <th class="text-center">钻头序列号</th>
                  <th class="text-center">直径</th>
                  <th class="text-center">齿形</th>
                  <th class="text-center">规格</th>
                  <th class="text-center">倒角</th>
                  <th class="text-center">编号</th>
                  <th class="text-center">等级</th>
                  <th class="text-center">数量</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="pdc in pdcs.filter((item) => item.numbers.length > 0)"
                >
                  <td>
                    {{
                      pdc.option_time
                        ? pdc.option_time
                        : $time(pdc.created_at).format('YYYY-MM-DD')
                    }}
                  </td>
                  <td
                    class="text-center"
                    v-html="pdc.numbers.join('<br />')"
                  ></td>
                  <td class="text-center">{{ pdc.diameter }}</td>
                  <td class="text-center">{{ pdc.tooth_type }}</td>
                  <td class="text-center">{{ pdc.specification }}</td>
                  <td class="text-center">{{ pdc.chamfering }}</td>
                  <td class="text-center">{{ pdc.serial_number }}</td>
                  <td class="text-center">{{ pdc.grade }}</td>
                  <td class="text-center">
                    {{ pdc.count }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { drillDetail } from '@/service/getData'

export default {
  data() {
    return {
      id: this.$route.params.id,
      drill: {},
      pdcs: [],
    }
  },

  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await drillDetail(this.id)
      if (res.status == 0) {
        this.drill = res.data.drill
        this.pdcs = res.data.map((pdc) => {
          let arr = pdc.drill_serial_numbers.split(',')

          pdc.numbers = []
          pdc.count = (pdc.number / arr.length).toFixed() || 0

          arr.map((item) => {
            if (
              item.substring(0, item.length - 1) ==
              this.drill.serial_number.substring(
                0,
                this.drill.serial_number.length - 1
              )
            ) {
              pdc.numbers.push(item)
            }
          })
          return pdc
        })
      }
    },
  },
}
</script>